import request from '@/utils/request'

export enum Handler {
  datalog = 'datalog',
}

// eslint-disable-next-line
type PanelQuery = any

interface Command {
  handler: Handler
  q: PanelQuery[]
}

export function SendCommand(cmd: Command) {
  return request.post('/rt', cmd)
}

interface ApplicationInfo {
  title: string
  subtitle: string
  logo: string
  windowPadding: string
}

export function GetAppInfo(): Promise<ApplicationInfo> {
  return request.get('/rt')
}
